import { DictionaryItemContent } from "../../components/configuration";

export default function DictionaryItem() {
  return (
    <>
      <DictionaryItemContent />
    </>
  );
}
